export default "__VITE_ASSET__D3bxuC1W__"